<div class="spinner" *ngIf="isBusy">
  <div class="spinnerBack"><img src="../../../assets/gifs/aguarde.gif"></div>  
</div> 
